/**
 * セッションキー
 */
export enum SessionKey {
  /**
   * 言語設定情報
   */
  language = 'language',
}
